(() => {
  const configNode = document.getElementById('mmc-conversion-tracking-config');
  if (!configNode) return;

  let config;
  try {
    config = JSON.parse(configNode.textContent);
  } catch (_error) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  const sentEvents = new Set();
  let googleTagLoaded = false;

  const analyticsAllowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return !privacy || privacy.analyticsProcessingAllowed();
  };

  const loadGoogleTag = () => {
    if (googleTagLoaded || !config.ga4Id || !analyticsAllowed()) return;
    googleTagLoaded = true;
    window.gtag = window.gtag || function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', config.ga4Id, { send_page_view: false });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(config.ga4Id)}`;
    document.head.appendChild(script);
  };

  const cleanParameters = (parameters) => Object.fromEntries(
    Object.entries(parameters).filter(([, value]) => value !== null && value !== undefined && value !== '')
  );

  const track = (eventName, parameters = {}, dedupeKey = '') => {
    const eventParameters = cleanParameters({
      ...parameters,
      page_location: window.location.href,
      page_title: document.title,
      product_id: config.productId,
      product_name: config.productTitle
    });
    const key = dedupeKey || `${eventName}:${JSON.stringify(eventParameters)}`;
    if (sentEvents.has(key)) return;
    sentEvents.add(key);

    window.dataLayer.push({
      event: `mmc_${eventName}`,
      ...eventParameters
    });

    if (analyticsAllowed()) {
      loadGoogleTag();
      window.gtag?.('event', eventName, eventParameters);
    }
  };

  const linkDetails = (link) => ({
    link_url: link.href,
    link_text: link.textContent.trim().replace(/\s+/g, ' ').slice(0, 100),
    link_location: link.closest('header') ? 'header' : link.closest('footer') ? 'footer' : 'body'
  });

  const isWhatsAppLink = (link) => /(?:wa\.me|api\.whatsapp\.com|whatsapp:)/i.test(link.href);
  const isRfqLink = (link) => {
    const text = `${link.textContent} ${link.getAttribute('aria-label') || ''}`;
    return /\b(?:rfq|request\s+(?:a\s+)?quote|get\s+(?:a\s+)?quote)\b/i.test(text)
      || /(?:request|rfq)[-_]?quote/i.test(link.href);
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    if (link.protocol === 'tel:') {
      track('click_to_call', { ...linkDetails(link), phone_number: link.href.replace(/^tel:/i, '') });
    }
    if (isWhatsAppLink(link)) {
      track('whatsapp_click', linkDetails(link));
    }
    if (isRfqLink(link)) {
      track('rfq_click', linkDetails(link));
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const isContactForm = /\/contact(?:$|[?#])/i.test(form.action)
      || form.querySelector('[name^="contact["]');
    if (!isContactForm) return;

    const isRfq = /(?:ask|quote|rfq)/i.test(`${form.id} ${form.className}`)
      || Boolean(form.querySelector('[name="contact[product]"]'));
    track('lead_form_submit', {
      form_id: form.id || 'contact-form',
      form_type: isRfq ? 'rfq' : 'contact'
    });
  }, true);

  const hasSuccessfulForm = Boolean(document.querySelector(
    '.notification.show.success, .form-ask__success, [data-contact-success="true"]'
  ));
  const thankYouPage = /\/(?:pages\/)?(?:thank-you|thank_you)(?:[/?#]|$)/i.test(window.location.pathname);
  const contactPosted = new URLSearchParams(window.location.search).get('contact_posted') === 'true';

  if (hasSuccessfulForm || contactPosted) {
    const formType = document.querySelector('.form-ask__success') ? 'rfq' : 'contact';
    track('generate_lead', {
      currency: 'USD',
      form_type: formType,
      lead_source: 'shopify_form_success'
    }, `generate_lead:${formType}:${window.location.pathname}`);
  }

  if (thankYouPage) {
    track('generate_lead', {
      currency: 'USD',
      form_type: 'thank_you_page',
      lead_source: 'thank_you_page'
    }, `generate_lead:thank_you:${window.location.pathname}`);
  }

  document.addEventListener('visitorConsentCollected', () => {
    if (analyticsAllowed()) loadGoogleTag();
  });
})();
